import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _9ce75da2 = () => interopDefault(import('../pages/users/list.vue' /* webpackChunkName: "pages/users/list" */))
const _574583a8 = () => interopDefault(import('../pages/users/rights.vue' /* webpackChunkName: "pages/users/rights" */))
const _3eb26608 = () => interopDefault(import('../pages/users/roles.vue' /* webpackChunkName: "pages/users/roles" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/users/list",
    component: _9ce75da2,
    name: "users-list"
  }, {
    path: "/users/rights",
    component: _574583a8,
    name: "users-rights"
  }, {
    path: "/users/roles",
    component: _3eb26608,
    name: "users-roles"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
